import firebase from 'firebase/app';
import tokenManagerService from '../../services/tokenManager';
import { managerService } from '../../services/manager.service';
import permissionService from '../../services/permission.service';

const state = {
  user: null,
  accessToken: null,
  isAuthenticated: false,
  permissions: {
    loaded: false,
    permissions: [],
    authContext: null,
    capabilities: {
      canViewExperiments: false,
      canEditExperiments: false,
      canEditOngoingExperiments: false,
      canSendPushNotifications: false,
      canSchedulePushNotifications: false,
      canCreateDraftMessages: false,
      canDeleteExperiments: false,
      canActivateExperiments: false,
      canViewISLKeys: false,
      canCreateISLKeys: false,
      canEditISLKeys: false,
      canDeleteISLKeys: false,
      isAdmin: false,
      canViewRetentionMessages: false,
      canCreateRetentionMessages: false,
      canEditRetentionMessages: false,
      canDeleteRetentionMessages: false,
      canApproveRetentionMessages: false
    }
  }
};

const mutations = {
  SET_IS_AUTH(state, payload) {
    const token = payload.accessToken;
    state.accessToken = token;
    state.isAuthenticated = token && token !== "" ? true : false;
  },
  
  CLEAR_AUTH_STATE(state) {
    state.accessToken = "";
    state.isAuthenticated = false;
  },
  
  SET_USER(state, payload) {
    state.user = payload;
  },
  
  SET_PERMISSIONS(state, payload) {
    state.permissions.loaded = true;
    state.permissions.permissions = payload.permissions || [];
    state.permissions.authContext = payload.authContext;
    state.permissions.capabilities = payload.capabilities || {};
  },
  
  SET_PERMISSIONS_LOADING(state, value) {
    state.permissions.loaded = !value;
  },
  
  RESET_PERMISSIONS(state) {
    state.permissions.loaded = false;
    state.permissions.permissions = [];
    state.permissions.authContext = null;
    state.permissions.capabilities = {
      canEditExperiments: false,
      canEditOngoingExperiments: false,
      canSendPushNotifications: false,
      canSchedulePushNotifications: false,
      canCreateDraftMessages: false,
      canDeleteExperiments: false,
      canActivateExperiments: false,
      canViewISLKeys: false,
      canCreateISLKeys: false,
      canEditISLKeys: false,
      canDeleteISLKeys: false,
      isAdmin: false,
      canViewRetentionMessages: false,
      canCreateRetentionMessages: false,
      canEditRetentionMessages: false,
      canDeleteRetentionMessages: false,
      canApproveRetentionMessages: false
    };
  }
};

const actions = {
  async setUser({ commit, dispatch, rootState }) {
    try {
      const userInfo = await tokenManagerService.getUserInfo();
      console.log("✅ Retrieved user info:", userInfo);
      commit("SET_USER", userInfo);
      
      // Load user permissions after setting user
      try {
        debugger;
        await dispatch('fetchUserPermissions');
        console.log("✅ User permissions loaded successfully");
        
        // After permissions are loaded, get Firebase token and sign in
        try {
          const tokenResponse = await managerService.getFirebaseToken();
          const firebaseToken = tokenResponse?.data?.firebaseToken;
          await firebase.auth().signInWithCustomToken(firebaseToken);
          console.log("Successfully signed in to Firebase.");
        } catch (fbError) {
          console.error("Firebase sign-in failed:", fbError);
        }
      } catch (permissionError) {
        console.warn("⚠️ Failed to load user permissions:", permissionError);
      }
      
      // Load config if we have an active app
      if (rootState.activeApp && rootState.activeApp !== "") {
        dispatch("fetchAllConfig", null, { root: true });
      }
    } catch (error) {
      console.error("❌ Error setting user:", error);
      commit("CLEAR_AUTH_STATE");
      throw error;
    }
  },

  async fetchUserPermissions({ commit }) {
    try {
      commit('SET_PERMISSIONS_LOADING', true);
      await permissionService.fetchUserPermissions();
      const permissionContext = permissionService.getPermissionContext();
      commit('SET_PERMISSIONS', permissionContext);
      return permissionContext;
    } catch (error) {
      console.error('Error fetching user permissions:', error);
      commit('RESET_PERMISSIONS');
      throw error;
    }
  },

  resetUserPermissions({ commit }) {
    commit('RESET_PERMISSIONS');
  }
};

const getters = {
  user: state => state.user,
  authToken: state => state.accessToken,
  isAuthenticated: state => state.isAuthenticated,
  permissions: state => state.permissions,
  userPermissions: state => state.permissions.permissions || [],
  permissionsLoaded: state => state.permissions.loaded,
  userCapabilities: state => state.permissions.capabilities,
  canEditExperiments: state => state.permissions.capabilities.canEditExperiments,
  canEditOngoingExperiments: state => state.permissions.capabilities.canEditOngoingExperiments,
  canSendPushNotifications: state => state.permissions.capabilities.canSendPushNotifications,
  canSchedulePushNotifications: state => state.permissions.capabilities.canSchedulePushNotifications,
  canCreateDraftMessages: state => state.permissions.capabilities.canCreateDraftMessages,
  canDeleteExperiments: state => state.permissions.capabilities.canDeleteExperiments,
  canActivateExperiments: state => state.permissions.capabilities.canActivateExperiments,
  canViewISLKeys: state => state.permissions.capabilities.canViewISLKeys,
  canCreateISLKeys: state => state.permissions.capabilities.canCreateISLKeys,
  canEditISLKeys: state => state.permissions.capabilities.canEditISLKeys,
  canDeleteISLKeys: state => state.permissions.capabilities.canDeleteISLKeys,
  userIsAdmin: state => state.permissions.capabilities.isAdmin,
  canViewExperiments: state => state.permissions.capabilities.canViewExperiments,
  authContext: state => state.permissions.authContext,
  canViewRetentionMessages: state => state.permissions.capabilities.canViewRetentionMessages,
  canCreateRetentionMessages: state => state.permissions.capabilities.canCreateRetentionMessages,
  canEditRetentionMessages: state => state.permissions.capabilities.canEditRetentionMessages,
  canDeleteRetentionMessages: state => state.permissions.capabilities.canDeleteRetentionMessages,
  canApproveRetentionMessages: state => state.permissions.capabilities.canApproveRetentionMessages
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

